import { Modal } from "react-bootstrap"
import { StyledButton } from "@modules/Common/styled"
import { DISPLAY_STATE } from "../constants"
import { addEvent } from "@utils/gtm"
import { useContext } from "react"
import { AppContext } from "AppContext"

interface IActivityCloseModal {
  showConfirmModal: boolean
  setShowConfirmModal: any
  setDisplayState: any
  userActivityAccessRefetch: any
}

export default function ActivityCloseModal({ showConfirmModal, userActivityAccessRefetch, setDisplayState, setShowConfirmModal }: IActivityCloseModal) {
  const { state } = useContext(AppContext)

  return (
    <Modal
      show={showConfirmModal}
      keyboard={false}
      backdrop="static"
      animation={false}
      centered>
      <Modal.Header><Modal.Title>Confirm</Modal.Title></Modal.Header>
      <Modal.Body>Hey, you may lose your progress for this activity. Are you sure you want to close?</Modal.Body>
      <Modal.Footer>
        <StyledButton onClick={() => {
          addEvent({
            "event": "close_no",
            "user_id": state.user?.id,
          })
          setShowConfirmModal(false)
        }}>No</StyledButton>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <StyledButton onClick={() => {
          addEvent({
            "event": "close_yes",
            "user_id": state.user?.id,
          })
          setShowConfirmModal(false)
          userActivityAccessRefetch()
          setDisplayState(DISPLAY_STATE.UNLOCK)
        }}>Yes</StyledButton>
      </Modal.Footer>
    </Modal>
  )
}
